const constants = {
  admin: {
    task_type: {
      type: {
        letter: 'Письмо',
        call: 'Звонок',
        chat: 'Чат',
        manual: 'Ручная',
        trigger: 'Триггер',
        escalation: 'Эскалация',
        unknown: 'Неизвестный',
        form: 'Форма',
      },
      source: {
        telephony: 'Телефония',
        hdi: 'HDI',
        communication: 'Коммуникации',
        escalation: 'Эскалация',
        form: 'Форма',
        student_cabinet: 'Личный кабинет ученика',
        unknown: 'Неизвестный',
      },
      subject: {
        student: 'Ученик',
        operator: 'Оператор',
        teacher: 'Преподаватель',
        all: 'Любой пользователь',
      },
    },
    weight_calculation: {
      operation_type: {
        summary: 'Суммирование',
        multiplication: 'Умножение',
      },
      data_type: {
        task_type: 'Тип задачи',
        resolution: 'Резолюция',
        priority: 'Приоритет',
        chat_priority: 'Приоритет чата',
        hour: 'Час',
      },
      cases: {
        header: {
          task_type: 'Тип задачи',
          resolution: 'Причина открытия',
          status: 'Статус',

          extra_active_on_specified: 'activeOnSpecified установлен',
          extra_complaint_theme_by_content: 'Тема жалобы на контент',
          extra_is_deadline_registered: 'isDeadlineRegistered установлен',
          extra_priority: 'Приоритет',
          extra_chat_priority: 'Приоритет чата',
          extra_chat_answer_received: 'chatAnswerReceived установлен',

          has_intro_lesson: 'Вводный урок сейчас',
          has_lesson: 'Урок сейчас',
          has_lesson_start_in_twenty_four_hours: 'Урок в ближайшие 24 часа',
          has_regular_schedule: 'Есть регулярный гарфик',

          student_premium_english: 'Ученик премиум',
          student_in_vacation: 'Ученик в отпуске',
          student_available_time_left: 'Оставшиеся свободное время у ученика',
          user_subject: 'Тип пользователя',
          task_assign_to_corp_pm: 'Задача закреплена за корп ПМ',
        },
        status: {
          waiting: 'В ожидании',
          postponed: 'Postponed',
          assigned: 'Взята в работу',
        },
        extra_priority: {
          urgent: 'Важный',
          average: 'Средний',
          minor: 'Низкий',
        },
        extra_chat_priority: {
          highest: 'Наивысший',
          high: 'Высокий',
          low: 'Низкий',
        },
        user_subject: {
          student: 'Ученик',
          teacher: 'Учитель',
        },
        boolean: {
          true: 'Да',
          false: 'Нет',
        },
      },
    },
  },
};

export default constants;
